import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';

@Component({
  selector: 'app-otp-verification-customer',
  templateUrl: './otp-verification-customer.component.html',
  styleUrls: ['./otp-verification-customer.component.scss']
})
export class OtpVerificationCustomerComponent implements OnInit, OnDestroy {
  // Reactive form to handle OTP input
  otpForm!: FormGroup;

  // Variable to hold entered OTP
  otp: string = '';

  // Email address retrieved from localStorage
  myEmail: any;

  // Masked version of email for display
  maskedEmail: string = '';

  // Timer countdown value (unused)
  countDowon: any = 2.59;

  // Control whether the resend OTP button is active
  resend_otp_active: boolean = false;

  // Time display (MM:SS)
  time!: string;

  // Indicates whether the countdown timer should run
  timerOn = true;

  // Stores remaining countdown time for display
  remainingTime: any;

  // Indicates if OTP has expired
  isExpire: boolean = false;

  // Used for clearing setTimeout
  timeOutId: any;

  // Controls loader visibility
  loading = false;

  showSuccess: boolean = false; // Controls success tick visibility

  constructor(
    private http: HttpClient,
    public commonService: CommonService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Initialize the OTP form with validation
    this.otpForm = new FormGroup({
      otp: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(4)])
    });

    this.otp = '';
    this.otpForm.reset();

    // Get remaining time from local storage or default to 180 seconds
    let timerd = localStorage.getItem('remainingTime');
    this.timer(timerd || 180);

    // Get user email from local storage
    this.myEmail = localStorage.getItem('email');

    // Masked email setup
    this.maskedEmail = this.maskEmail(this.myEmail);
  }

  // Called when OTP input is changed (if using custom input field)
  onOtpChange(otp: any) {
    this.otp = otp;
    this.otpForm.get('otp')?.setValue(otp);
  }

  // Verifies the OTP entered by the user
  navigateToVerifyCustomer() {
    let userData = {
      email: this.myEmail,
      otp: this.otp,
      userType: 'CUSTOMER',
    };

    if (!this.otp || this.otp.length !== 4) {
      this.commonService.errorToast('Please enter a valid 4-digit OTP');
      return;
    }

    this.loading = true;
    this.commonService.postApi('user/verifyOTP', userData, 0).subscribe(
      (res: any) => {
        this.loading = false;
        if (res.responseCode == 200) {
          this.showSuccess = true;
          this.commonService.showSuccessToast('OTP verified successfully!');
          setTimeout(() => {
            this.showSuccess = false;
            this.router.navigate(['/login']);
          }, 1500); // Delay navigation to show success tick for 1.5 seconds
        }
      },
      err => {
        this.loading = false;
        this.commonService.errorToast(err['responseMessage'] || 'Incorrect OTP, please try again');
        // Adding a small delay to ensure the error toast is rendered before clearing the OTP fields
        setTimeout(() => {
          this.otp = ''; // Clear the local variable
          this.otpForm.get('otp')?.setValue(''); // Explicitly set the form control value to clear the input
          this.otpForm.markAsUntouched(); // Mark as untouched to clear any validation error states
          this.otpForm.markAsPristine(); // Mark as pristine
        }, 100); // 100ms delay
      }
    );
  }

  // Sends a new OTP to the user if the previous one expired
  resendOtp() {
    if (!this.isExpire) {
      return;
    }

    this.myEmail = localStorage.getItem('email');
    let email = {
      email: this.myEmail,
      userType: 'CUSTOMER',
    };

    this.commonService.postApi('user/resendOTP', email, 0).subscribe(
      res => {
        console.log(res, "rrrr");
        if (res['responseCode'] == 200) {
          this.otp = '';
          this.otpForm.reset();
          this.timer(180); // Restart the timer
          this.isExpire = false;
          this.commonService.successToast(res['responseMessage']);
        }
      },
      err => {
        this.commonService.errorToast(err['responseMessage']);
      }
    );
  }

  // Controls the countdown timer logic
  timer(remaining: any) {
    let m: any = Math.floor(remaining / 60);
    let s: any = remaining % 60;

    m = m < 10 ? '' + m : m;
    s = s < 10 ? '0' + s : s;
    this.remainingTime = m + ':' + s;

    remaining -= 1;
    localStorage.setItem('remainingTime', remaining);

    if (remaining >= 0 && this.timerOn) {
      this.timeOutId = setTimeout(() => {
        this.timer(remaining);
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      return;
    }

    // Timer expired
    localStorage.removeItem('remainingTime');
    this.isExpire = true;
  }

  // Simulates loading state (used optionally)
  load() {
    this.loading = true;

    setTimeout(() => {
      this.loading = false;
    }, 60000); // 1 minute
  }

  // Clears timer and localStorage values on component destroy
  ngOnDestroy(): void {
    this.timer(0);
    clearTimeout(this.timeOutId);
    localStorage.removeItem('remainingTime');
  }

  // Masks the email for display (e.g., johndoe@gmail.com → joh***@gmail.com)
  private maskEmail(email: string): string {
    if (!email) return '';
    const [name, domain] = email.split('@');
    const maskedName = name.length > 3 ? name.substring(0, 3) + '***' : name + '***';
    return `${maskedName}@${domain}`;
  }
}